const MaintenanceTypeReducer = (state ={
                                paginationCount:50,
                                next : null,
                                previous : null,
                                rs : null,
                                query : '',
  },action) => {
    switch (action.type) {
        case "MasterMaintenanceTypeSetRS":
            state = {
                      ...state,
                      next : action.payload.next,
                      previous : action.payload.previous,
                      rs:action.payload.rs,
                      query : action.payload.query,
                    }
            break;
        default:
            break;

    }
    return state;
};

export default MaintenanceTypeReducer;



// WEBPACK FOOTER //
// ./src/App/store/master/maintenance_type.js